import React from 'react'
import { motion, usePresence } from 'motion/react'

const transition = { 
    type: 'spring', 
    stiffness: 1000, 
    damping: 50, 
    mass: 1 
}

function SwipeMotion({ children, key }) {
    const [isPresent, safeToRemove] = usePresence()
    // console.log('RERENDER ListItem', num)

    const animations = {
        layout: true,
        
        initial: 'initial',
        // exit: {
        //       opacity: 1,
        //       y: 150, // Moves the element upwards
        //       transition: { duration: 0.5 },
        // },
        animate: isPresent ? 'in' : 'out',
        // whileTap: 'tapped',
        variants: {
        //   in: { x: 0, y: 0, opacity: 1, rotate: 0 },
        //   out: { x: -10, y: 100, opacity: 0, rotate: 10 },
            in: { x: 0, opacity: 1},
            out: { x: -10, opacity: 1 },
            initial: {x: 10, opacity: 1}
        },
        // onAnimationComplete: () => !isPresent && safeToRemove(),
        transition
    }
    // const Component = motion?.[tag_name] ?? motion.div
    return (
        <motion.div 
            {...animations} 
            className='motion-item' 
            key={key}

            // initial={{ opacity: 0, x:-10 }}
            // animate={{ opacity: 1, x:0 }}
            // exit={{ opacity: 0, x:10 }}
        >
            {children}
        </motion.div>
    )
}


export default SwipeMotion